import { Component, computed, input } from '@angular/core';


@Component({
    selector: 'ui-badge',
    styles: [
        `
        :host {
            display: inline-block;
            padding: .25em .4em;
            font-size: .8em;
            font-weight: bold;
            line-height: 1;
            text-align: center;
            white-space: nowrap;
            vertical-align: baseline;
            border-radius: .25rem;
        }
        :host.pill {
            padding-left: .6em;
            padding-right: .6em;
            border-radius: 10rem;
        }
        :host.info {
            color: var(--light, white);
            background: var(--info, blue);
        }
        :host.danger {
            color: var(--light, white);
            background: var(--danger, red);
        }
        :host.warning {
            color: var(--light, white);
            background: var(--warning, orange);
        }
        :host.success {
            color: var(--light, white);
            background: var(--success, green);
        }
        :host.primary {
            color: var(--light, white);
            background: var(--primary, blue);
        }
        :host.dark {
            color: var(--light, white);
            background: var(--dark, black);
        }
        `
    ],
    host: {
        '[class]': 'color()',
        '[class.pill]': 'pill()',
    },
    template: `
        {{ value() }}
    `,
})
export class BadgeComponent {

    color = input<'success' | 'info' | 'warning' | 'danger' | 'primary' | 'dark'>('warning');

    text = input<string>();

    count = input<number>();

    limit = input(999);

    pill = input(false);

    value = computed(() => {
        const text = this.text();
        const count = this.count();
        const limit = this.limit();

        if (typeof count !== 'undefined') {
            if (count > limit) {
                return `${limit}+`;
            } else {
                return `${count}`;
            }
        }
        return text;
    });
}
